import attachmentsApi from 'components/attachments/api';
import { attachmentsPath } from './config';
import { deleteRequest, post, put } from 'helpers/api';

export function createFolder(path, name, parentFolderId) {
  return post(path, { name, parentFolderId });
}

export function renameFolder(folder, name) {
  put(folder.path, { name });
  return { ...folder, name };
}

export function deleteFolder(folder) {
  return deleteRequest(folder.path);
}

export function setFolderParent(folder, parentFolder) {
  const changes = { parentFolderId: parentFolder.id };
  put(folder.path, changes);
  return { ...folder, ...changes };
}

export function createAttachment(attachable, file, config, folder) {
  return attachmentsApi.createAttachment(attachmentsPath, attachable, file, config, { folder_id: folder.id });
}

export function deleteAttachment(attachment) {
  return deleteRequest(attachment.path);
}

export function setAttachmentFolder(attachment, folder) {
  attachmentsApi.updateAttachment(attachment, { folder_id: folder.id });
  return { ...attachment, folderId: folder.id };
}

export function renameAttachment(attachment, name) {
  attachmentsApi.updateAttachment(attachment, { display_name: name });
  return { ...attachment, displayName: name };
}
